import { render, staticRenderFns } from "./BaseStates.vue?vue&type=template&id=06f30198"
import script from "./BaseStates.vue?vue&type=script&lang=js"
export * from "./BaseStates.vue?vue&type=script&lang=js"
import style0 from "./BaseStates.vue?vue&type=style&index=0&id=06f30198&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports